import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { useHistory } from 'react-router';
import Form from '@dashboard/components/Formik/Form';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { useToast } from '@dashboard/context/ToastContext';
import { apiUrl } from '@dashboard/services/env';
import request from '@dashboard/services/request';
import { templateCategoriesKey } from '@dashboard/lib/queryKeys';

const TemplateCategoryAdd = () => {
  const { emitToast } = useToast();
  const { token } = useAuth();
  const history = useHistory();
  const queryClient = useQueryClient();

  return (
    <div className="max-w-xl mx-auto mt-16">
      <h1 className="text-2xl font-bold mb-4">Add Template Category</h1>
      <Form
        initialValues={{
          title: '',
          order: '',
          publicTitle: '',
          publicDescription: '',
        }}
        fields={[
          {
            name: 'title',
            required: true,
            type: 'text',
            label: 'Category title',
          },
          {
            name: 'publicTitle',
            required: false,
            type: 'text',
            label: 'Page title',
          },
          {
            name: 'publicDescription',
            required: false,
            type: 'textarea',
            label: 'Page description',
            minRows: 8,
            autosize: true,
          },
          {
            name: 'order',
            required: false,
            type: 'number',
            label: 'Order',
            placeholder: 'Automatically generated if left empty',
          },
        ]}
        showState={false}
        onSubmit={async values => {
          const response = await request(`${apiUrl}/templates/categories`, token, {
            method: 'POST',
            body: JSON.stringify(values),
          });

          return {
            data: response.data,
            error: response,
            onSuccess: () => {
              emitToast({
                title: 'Category added',
              });
              queryClient.invalidateQueries({ queryKey: templateCategoriesKey });
              history.push('/admin/template-categories');
            },
          };
        }}
      />
    </div>
  );
};

export default TemplateCategoryAdd;
